import * as React from 'react';
import { MenuItem, TextField, TextFieldProps } from "@material-ui/core";

export const usaStates = [undefined, 'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];
export const usaMenuItems = usaStates.map(x => <MenuItem key={x??""} value={x?.toString() ?? ""}>{x?.toString() ?? "Select"}</MenuItem>);

export const StateTextField = React.forwardRef((props: TextFieldProps, ref: any) => {
  return <TextField {...props} ref={ref} select={true}>
    {usaMenuItems}
  </TextField>;
});